import React, { useEffect } from 'react';
const CrispChat = () => {
  const apiMode = process.env.NEXT_PUBLIC_API_MODE;
  const forceCrisp = process.env.NEXT_PUBLIC_ENABLE_CRISP === 'true';
  useEffect(() => {
    // Check if the script is already added to avoid duplicates
    // Load Crisp in production OR when explicitly enabled via NEXT_PUBLIC_ENABLE_CRISP
    const shouldLoadCrisp = apiMode?.toLowerCase() === 'production' || forceCrisp;
    if (!window.$crisp && shouldLoadCrisp) {
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = "c60312c8-6d01-43ad-bbe1-ac12b9df831a";
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      script.onload = () => {
        // Hide Crisp chat bubble on mobile devices to reduce visual clutter
        // Users can access chat via the mobile menu instead
        if (window.$crisp) {
          window.$crisp.push(["config", "hide:on:mobile", [true]]);

          // Re-hide the bubble when chat is closed on mobile
          // This ensures the floating bubble doesn't persist after opening via menu
          window.$crisp.push(["on", "chat:closed", () => {
            // Check if on mobile (screen width < 768px)
            if (window.innerWidth < 768) {
              window.$crisp.push(["config", "hide:on:mobile", [true]]);
            }
          }]);
        }
      };
      script.onerror = error => {
        console.error('Error loading Crisp chat script:', error);
      };
      document.head.appendChild(script);
    }
  }, [apiMode, forceCrisp]); // Add dependencies

  return null; // This component doesn't render anything
};

/**
 * Opens the Crisp chat widget programmatically.
 * Use this to trigger chat from custom UI elements (e.g., mobile menu).
 * On mobile, we temporarily disable hide:on:mobile to show and open the chat.
 */
export const openCrispChat = () => {
  if (typeof window !== 'undefined' && window.$crisp) {
    // Temporarily disable hide:on:mobile so chat can be shown
    window.$crisp.push(["config", "hide:on:mobile", [false]]);
    // Show the chatbox (make it visible)
    window.$crisp.push(["do", "chat:show"]);
    // Open the chatbox
    window.$crisp.push(["do", "chat:open"]);
  }
};
export default CrispChat;